module.exports = __webpack_public_path__ + "img/lookbook_6_left.12b7d83a.png";